<template>
  
  <b-row>
    <b-col>
      <b-card
        style="margin:0;border:1px solid #2980b9;padding:0 10px"
        no-body
        :class="{ 'open': visibleBody }"
      >
        <b-card-header
          style="color: black; font:45px; padding: 0 1px; cursor: pointer"
          :class="{ 'collapsed': !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="onVisibleBody(!visibleBody)"
        >
          <span class="lead collapse-title">
            <strong>PLAN DE TRATAMIENTO </strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >
          <b-card-body style="padding: 1.5rem">
            <b-form-group style="margin:0" label="Escribir el plan tratamiento: ">
              <b-form-textarea
                v-model="planTratamiento"
                placeholder="Describa el plan tratamiento"
                rows="3"
                no-resize
              />
            </b-form-group>
            <b-form-group  class = "mt-1" >
              <b-button  @click = "copyAS400()" variant = "info">
                AS400  <i class="fas fa-copy"/>
              </b-button>
            </b-form-group>
          </b-card-body>
        </b-collapse>
        
      </b-card>
    </b-col>
  </b-row>

</template>

<script>
import { mapState } from 'vuex';
import { copyText } from '@/shared/helpers';

export default {
  name: "PlanTratamiento",

  data() {
    return {
      visibleBody: false,
      planTratamiento: `1.- PLAN EDUCACIONAL: \n2.- PLAN DIAGNÓSTICO: \n3.- PLAN TERAPÉUTICO:`,
    };
  },

  created(){
    this.loadDataLS();
  },

  methods: {


    loadDataLS(){
      const anamnesis       = JSON.parse(localStorage.getItem("crearAnamnesis"));
      const planTratamiento = anamnesis?.planTratamiento;

      if(!planTratamiento) return;
      this.planTratamiento  = planTratamiento;
    },


    onVisibleBody(value) {
      this.visibleBody = value;
    },

    copyAS400() {
      copyText(this.planTratamiento)
      
    }
  },
  computed :{
    ...mapState({
      stPlanTratamiento: state => state.atencionCita.anamnesis?.planTratamiento,
    }),
  },

  watch: {
    stPlanTratamiento : {
      deep: true,
      handler(newValue) {
        this.planTratamiento = newValue
      }
    },
    planTratamiento: {
      deep: true,
      handler(newValue) {
        this.$store.commit("setPlanTratamiento", newValue);
      }
    }
  }
}
</script>

<style>

</style>